/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';

import * as React from 'react';

import { IProductApellationData } from './product-apellation.data';
import { IProductApellationProps } from './product-apellation.props.autogenerated';

/**
 *
 * ProductApellation component
 * @extends {React.PureComponent<IProductApellationProps<IProductApellationData>>}
 */
class ProductApellation extends React.PureComponent<
  IProductApellationProps<IProductApellationData>
> {
  private _productAttributeApellation: string = 'SLR APPELLATION';
  public render(): JSX.Element | null {
    const content: IProductApellationData = this.props.data;
    if (
      !(
        content &&
        content.productSpecificationData &&
        content.productSpecificationData.result
      )
    ) {
      return null;
    }
    const productAttributes = content.productSpecificationData.result;
    const productAttribute = productAttributes.filter(
      attribute =>
        attribute.Name &&
        attribute.Name.toUpperCase() === this._productAttributeApellation
    );
    if (
      productAttribute &&
      productAttribute.length &&
      productAttribute[0].TextValue
    ) {
      return (
        <div className='product-attribute'>
          <div className='product-attribute-apellation'>
            <RichTextComponent
              className='product-attribute-apellation-value'
              text={productAttribute[0].TextValue}
            />
          </div>
        </div>
      );
    }
    return null;
  }
}

export default ProductApellation;
